"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ville-d-anaunia": {
    "e3b63721": [{
      "hkey": "e030c2e5",
      "slug": "ville-d-anaunia",
      "name": "Ville d'Anaunia",
      "primary": true,
      "skipSearch": false
    }],
    "campo": [{
      "hkey": "e030c2e5",
      "slug": "ville-d-anaunia",
      "name": "Ville d'Anaunia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "96554169": [{
      "hkey": "e030c2e5",
      "slug": "ville-d-anaunia",
      "name": "Ville d'Anaunia",
      "primary": true,
      "skipSearch": false
    }],
    "centier": [{
      "hkey": "e030c2e5",
      "slug": "ville-d-anaunia",
      "name": "Ville d'Anaunia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4a00ff36": [{
      "hkey": "e030c2e5",
      "slug": "ville-d-anaunia",
      "name": "Ville d'Anaunia",
      "primary": true,
      "skipSearch": false
    }],
    "rallo": [{
      "hkey": "e030c2e5",
      "slug": "ville-d-anaunia",
      "name": "Ville d'Anaunia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f7ec1a77": [{
      "hkey": "e030c2e5",
      "slug": "ville-d-anaunia",
      "name": "Ville d'Anaunia",
      "primary": true,
      "skipSearch": false
    }],
    "sanzenone-localita-santa-giustina": [{
      "hkey": "e030c2e5",
      "slug": "ville-d-anaunia",
      "name": "Ville d'Anaunia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;